import gql from "../gql";
export default gql `
  fragment EarnedAward on EarnedAward {
    __typename
    id
    earnedPoints
    type
    label
    imageUrl
    learningName
    learningOrgId
    learningUrl
    awardedOn
  }
`;
